import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EventsService } from 'app/shared/service/events.service';
import { _localStorage } from 'app/shared/utils';
import { tap } from 'rxjs/operators';
import { centerToBounds, centerToProperty, changeBaseMap, locate, setView } from './map.actions';


@Injectable()
export class MapEffects {

    baseMapSet = createEffect(() =>
        this.actions.pipe(
            ofType(changeBaseMap),
            tap(({ baseMap }) => {
                _localStorage.setItem('ap-basemap-4', baseMap); // todo: @twista - find a way how to improve LS persisting
            })
        ),
    { dispatch: false }
    );

    centerToPropertyEffect = createEffect(() =>
        this.actions.pipe(
            ofType(centerToProperty),
            tap(action => {
                this.eventsService.centerToProperty.next(action);
            })
        ),
    { dispatch: false }
    );

    centerToBoundsEffect = createEffect(() =>
            this.actions.pipe(
                ofType(centerToBounds),
                tap(action => {
                    this.eventsService.centerToBounds.next({ bounds: action.bounds });
                })
            ),
        { dispatch: false }
    );


    locateEffect = createEffect(() =>
        this.actions.pipe(
            ofType(locate),
            tap(action => {
                this.eventsService.locate.next(action);
            })
        ),
    { dispatch: false }
    );

    setViewEffect = createEffect(() =>
        this.actions.pipe(
            ofType(setView),
            tap(action => {
                this.eventsService.setView.next(action);
            })
        ),
    { dispatch: false }
    );

    constructor(private actions: Actions, private eventsService: EventsService) {}
}
